<template>

    <md-dialog id="general-form-wrapper" :ref='dialogRef' :md-click-outside-to-close='true'>
        <md-dialog-title>
            <h3 class="md-headline">Images</h3>
        </md-dialog-title>
            <md-tabs class="md-transparent">
                <md-tab id="tab1" md-label="Upload and Crop" >
                    <CropperImage :aspect="aspectRatio" @uploadCustomThumbnail="uploadThumbnail" @uploadHero="uploadHero" @upload2x3="upload2x3"/>
                </md-tab>
                <md-tab id="tab2" md-label="Upload from gallery">
                    <Loader :loading='loading' :size='45' />
                    <div class="container-images">
                        <div v-for="image in getImagesCropped"   >
                            <img :src="baseUrl+image" alt="" class="img-folder" @click="selectImage(image)">
                        </div>
                    </div>
                </md-tab>
            </md-tabs>
    </md-dialog>
</template>

<script>
import uuid from 'uuid';
import mediaItemService from '../../services/mediaItemService';
import Loader from '../../shared-components/Loader';
import CropperImage from './CropperImage.vue';

export default {
    components: {
        Loader,
        CropperImage,
    },
    props: {},
    data() {
        return {
            dialogRef: uuid.v4(),
            loading: false,
            getImagesCropped: [],
            baseUrl: `https://s3.us-east-1.amazonaws.com/${process.env.IMAGES_BUCKET_NAME}/`,
            aspectRatio:''
        };
    },
    methods: {
        uploadThumbnail({url}){
            this.$emit('uploadCustomThumbnail', {url: url});
            this.closeDialog();
        },
        uploadHero({url}){
            this.$emit('uploadHero', {url: url});
            this.closeDialog();
        },
        upload2x3({url}){
            this.$emit('upload2x3', {url: url});
            this.closeDialog();
        },
        selectImage(image){
            this.$emit('selectedGalleryImage', image);
            this.closeDialog();
        },
        loadImages(folderName){
            mediaItemService.getImages(folderName)
                .then((res) => {
                    this.getImagesCropped = res.data.images;
                    this.loading = false;
                })
        },
        closeDialog() {
            this.getImagesCropped = [];
            this.aspectRatio = '';
            const ref = this.dialogRef;
            this.$refs[ref].close();
            this.$emit('closed');
        },
        openDialog(aspectImageSelected) {
            if(aspectImageSelected === 'custom') {this.aspectRatio = '16/9'}
            if(aspectImageSelected === 'heroimage') {this.aspectRatio = '9/4'}
            if(aspectImageSelected === 'thumbnail2x3') {this.aspectRatio = '2/3'}
            this.getImagesCropped = [];
            this.loadImages(aspectImageSelected);
            this.loading = true;
            const ref = this.dialogRef;
            this.$refs[ref].open();
        },
    },
};
</script>

<style lang="scss" scoped>

.container-images {
    width: 100%;
    display: flex;
    flex-wrap: wrap ;
    justify-content: center;
    max-height: 400px;
    overflow-y: auto;
}

.img-folder{
    width: 200px;
    height: 100px;
    margin: 5px;
    object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/upload/PopUpImages.vue